export default {
  primary: '#3294f7',
  background: '#ecf6ff',
  secondaryBackground: '#fff',
  primaryText: '#000',
  secondaryText: '#ffffff',
  boxShadow: '0px 5px 10px rgba(170, 145, 196, 0.3)',
}